module.exports = __webpack_public_path__ + "static/media/abbottabad.3d361370.svg";